import React from 'react';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { Notification } from '@ecosystem/newron-design-system/build/exports/overlays';
import { DataWarning } from '../../types';
import { capitalize } from '../../common/util';

const { Alert } = feedbackV2;

type WarningSettingsProps = {
  appendKpis?: boolean;
};

type WarningsContainerProps = {
  className?: string;
  style?: { [k: string]: any };
  warnings: DataWarning[];
  settings?: WarningSettingsProps;
};

export const WarningsDisplay: React.FC<WarningsContainerProps> = ({ warnings, className, style, settings }) => {
  if (!warnings?.length) {
    return null;
  }
  const composedWarnings = composeWarningMessage(warnings, settings);
  return (
    <>
      {composedWarnings.map(({ message, level }, index) => (
        <div className={className} style={style} key={index}>
          <Alert key={index} title={message} type={level as Notification} />
        </div>
      ))}
    </>
  );
};

const composeWarningMessage = (warnings: DataWarning[], settings: WarningSettingsProps) => {
  return warnings.map(([message, { kpis, level }]) => {
    if (settings?.appendKpis) {
      const kpisLabel = kpis.map(k => k.label).join(', ');
      return {
        message: `${kpisLabel} ${message}`,
        level,
      };
    }

    return {
      message: capitalize(message),
      level,
    };
  });
};
